import { render, staticRenderFns } from "./surplus_material.vue?vue&type=template&id=3d47e86d"
import script from "./surplus_material.vue?vue&type=script&lang=js"
export * from "./surplus_material.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports